<template>
  <div class="card">
    <form @submit.prevent="submitLogin">
      <div class="card-content">
        <span class="card-title center">{{this.$title()}}</span>

        <div class="center">
          <a class="black-text">Теория и практика немецкого языка</a>
          <br />
          <a class="black-text">с искусственным интеллектом</a>
          <br />
          <a class="indigo-text">erste.lehrerin@gmail.com</a>
        </div>
        
        <br />
        
        <div>        
          <label>
            <input type="checkbox" v-model="anonymous" />
            <span>
              Войти без регистрации,
              <br />хочу пока просто попробовать.              
            </span>
          </label>
        
        </div>

        <div class="input-field">
          <input
            v-bind:disabled="anonymous"
            id="email"
            type="text"
            v-model.trim="email"
            :class="{invalid: ($v.email.$dirty && !$v.email.required) || ($v.email.$dirty && !$v.email.email)}"
          />
          <label for="email">Email</label>
          <small
            class="helper-text invalid"
            v-if="$v.email.$dirty && !$v.email.required"
          >Введите email</small>
          <small
            class="helper-text invalid"
            v-else-if="$v.email.$dirty && !$v.email.email"
          >Некорректный email</small>
        </div>

        <div class="input-field">
          <input
            v-bind:disabled="anonymous"
            id="password"
            type="password"
            v-model.trim="password"
            :class="{invalid: ($v.password.$dirty && !$v.password.required) || ($v.password.$dirty && !$v.password.minLength)}"
          />
          <label for="password">Пароль</label>
          <small
            class="helper-text invalid"
            v-if="$v.password.$dirty && !$v.password.required"
          >Введите пароль</small>
          <small
            class="helper-text invalid"
            v-else-if="$v.password.$dirty && !$v.password.minLength"
          >Пароль должен быть не менее {{$v.password.$params.minLength.min}} символов. Сейчас он {{password.length}}.</small>
        </div>
        
        
      </div>
      <div class="card-action">
        <p class="helper-text invalid">{{getMessages()}}</p>
        <div>
          <button class="btn blue darken-4 waves-effect waves-light auth-submit" type="submit">
            Войти
            <i class="material-icons right">send</i>
          </button>
        </div>

        <p class="center">
          Ещё нет регистрации?
          <router-link to="/register">Регистрация</router-link>
        </p>
      </div>

      <div class="card-content">
        <a class="grey-text">Версия: {{version}}</a>
        <br />
        <a class="grey-text">© 2021 Andrei Pushnin</a>
        <br />
      </div>
    </form>
  </div>
</template>



<script>
import bcrypt from "bcryptjs/dist/bcrypt.min.js";
import { email, required, minLength } from "vuelidate/lib/validators";

export default {
  name: "login",
  metaInfo() {
    return {
      title: this.$title("Вход")
    };
  },
  data: () => ({
    email: "",
    password: "",
    anonymous: false,
    passwordMsg: null
  }),
  computed: {
    server_msg() {
      return this.$store.getters.serverMsg;
    },
    user() {
      return this.$store.getters.user;
    },
    version() {
      return process.env.VUE_APP_VERSION;
    }
  },
  validations: {
    email: { email, required },
    password: { required, minLength: minLength(6) }
  },
  methods: {
    async submitLogin() {
      if (!this.anonymous) {
        if (this.$v.$invalid) {
          this.$v.$touch();
          return;
        }
        // логин для получения по e-mail hashed pass для проверки
        await this.$store.dispatch("login", {
          email: this.email
        });

        if (this.user.pass) {
          let that = this;
          bcrypt.compare(this.password, this.user.pass, function(err, result) {
            if (result === true) {
              // логин для подтверждения входа и лога в БД
              that.$store.dispatch("login", {
                email: that.email,
                islogin: true
              });
              that.$router.push("/");
            } else {
              that.passwordMsg = "pass_incorrect";
              that.$store.commit("clearUser");
            }
          });
        }
      } else {
        // автоматически регистрируем анонимного пользователя
        let that = this;
        let email_anonymous = "anonymous" + new Date().getTime() + "@mail.com";
        let password_anonymous = "123456";
        let name_anonymous = "профиль";
        bcrypt.genSalt(10, function(err, salt) {
          bcrypt.hash(password_anonymous, salt, async function(err, hash) {
            await that.$store.dispatch("register", {
              email: email_anonymous,
              pass: hash,
              name: name_anonymous
            });
            if (that.$store.getters.user.id) {
              that.$router.push("/");
            }
          });
        });
      }
    },
    getMessages() {
      return this.$transmsg(
        this.server_msg.connection_error ||
          this.server_msg.server_error ||
          this.server_msg.server_info ||
          this.passwordMsg
      );
    }
  }
};
</script>
